import api from './api';
import authHeader from './auth-header';

class AttendanceService {
    getEmployeesWithStatus(date) {
        const url = `/attendance/status?date=${date}`;
        return api.get(url, { headers: authHeader() });
    }

    getEmployeeHistory(employeeId) {
        return api.get(`/attendance/employee/${employeeId}/history`, { headers: authHeader() });
    }

    updateAttendanceRecord(id, recordType, data) {
        const payload = {
            recordType,
            ...data,
        };
        return api.put(`/admin/attendance/${id}`, payload, { headers: authHeader() });
    }

    deleteBreakRecord(id) {
        return api.delete(`/admin/break/${id}`, { headers: authHeader() });
    }

    createAttendanceRecord(employeeId, workplaceId, data) {
        const payload = {
            employee_id: employeeId,
            workplace_id: workplaceId,
            ...data,
        };
        return api.post(`/admin/attendance`, payload, { headers: authHeader() });
    }

    createBreakRecord(attendanceId, data) {
        const payload = {
            attendance_id: attendanceId,
            ...data,
        };
        return api.post(`/admin/break`, payload, { headers: authHeader() });
    }

    deleteAttendanceRecord(id) {
        return api.delete(`/admin/attendance/${id}`, { headers: authHeader() });
    }
}

const attendance_service = new AttendanceService();
export default attendance_service; 